import { inject, Injectable } from '@angular/core';
import { Observable, from, catchError, throwError } from 'rxjs';
import {
  AuditLogApi,
  AuditLogList,
  QueryAuditLogsScopeTypeEnum,
  QueryAuditLogsEventTypeEnum,
  QueryAuditLogsRequest,
} from '@tourfold/libraries/tf-api-client-public-v2';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  private readonly auditLogsApi = inject(AuditLogApi);

  getAuditLogsData(data: QueryAuditLogsRequest): Observable<AuditLogList> {
    return from(
      this.auditLogsApi.queryAuditLogs({
        page: data.page ?? 0,
        size: data.size ?? 10,
        from: data.from ? new Date(data.from) : undefined,
        to: data.to ? new Date(data.to) : undefined,
        scopeType: data.scopeType as QueryAuditLogsScopeTypeEnum,
        scopeId: data.scopeId,
        eventType: data.eventType as QueryAuditLogsEventTypeEnum,
        actorId: data.actorId,
      })
    ).pipe(
      catchError((error: unknown) => {
        return throwError(() => error);
      })
    );
  }
}
